/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { getGetAPIMethod } from "@neum/frontend-shared/utils/api";

export const getTemplateObject = getGetAPIMethod(
    "/v1/template/{template_id}", 
    { baseUrl: import.meta.env.REACT_APP_ENDPOINT }
);
export const getTemplateDefinition = getGetAPIMethod(
    "/v2/template_definition/{template_id}",
    { baseUrl: import.meta.env.REACT_APP_ENDPOINT }
);